/* Lead capture popup — vanilla JS, no dependencies.
 * Flow: (teaser) → email → (qualifier) → (sms) → success (code shown, or 'check your email'). Submits to Klaviyo's client API.
 * Config comes from the JSON blob rendered by sections/lead-capture-popup.liquid.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-lcp]');
  if (!root) return;

  var cfgEl = root.querySelector('[data-lcp-config]');
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var STORAGE_KEY = 'piventra_lead_popup';
  var LANDING_KEY = 'piventra_lead_landing';
  var KLAVIYO_REVISION = '2025-07-15';
  var KLAVIYO_BASE = 'https://a.klaviyo.com/client/';
  var IP_ECHO = 'https://api64.ipify.org?format=json';
  var DAY_MS = 86400000;

  var params = new URLSearchParams(window.location.search);
  var preview = params.get('popup_preview') === '1';
  if (params.get('popup_reset') === '1') {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  }

  /* ---------- state ---------- */
  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }
  function writeState(patch) {
    try {
      var next = Object.assign(readState(), patch);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) { /* storage blocked: popup just behaves as first visit */ }
  }

  /* ---------- landing page (which product brought this visit in) ----------
     Recorded once per browser session, on the first page this script runs on,
     so a signup made three pages later still knows where the visit began. The
     MAILING dashboard groups popup signups by it ("Site Popup Landing*"). */
  function landing() {
    var cur = {
      path: window.location.pathname + window.location.search,
      product: cfg.product || '',
      ref: String(document.referrer || '').slice(0, 300),
      at: Date.now()
    };
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(LANDING_KEY) || 'null');
      if (saved && saved.path) return saved;
      window.sessionStorage.setItem(LANDING_KEY, JSON.stringify(cur));
    } catch (e) { /* storage blocked: this page counts as the landing page */ }
    return cur;
  }
  var landed = landing();

  function eligible() {
    if (preview) return true;
    var s = readState();
    var now = Date.now();
    if (s.subscribedAt) return false;
    // Once the popup has been SEEN (shown, dismissed, or ignored) start the cooldown,
    // so a visitor gets it once and then not again until the cooldown passes.
    var lastSeen = Math.max(s.shownAt || 0, s.dismissedAt || 0);
    if (lastSeen && now - lastSeen < (cfg.cooldownDays || 3) * DAY_MS) return false;
    return true;
  }

  /* ---------- IP allowlist gate (restricted mode) ---------- */
  function ipMatches(ip, entry) {
    ip = ip.toLowerCase();
    entry = entry.toLowerCase();
    if (!entry) return false;
    if (entry === ip) return true;
    var last = entry.charAt(entry.length - 1);
    if (last === '.' || last === ':') return ip.indexOf(entry) === 0;
    return false;
  }

  function gate(cb) {
    if (cfg.mode !== 'restricted') return cb(true);
    var list = String(cfg.allowedIps || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!list.length) return cb(false);
    fetch(IP_ECHO, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ip = (j && j.ip) ? String(j.ip) : '';
        cb(!!ip && list.some(function (e) { return ipMatches(ip, e); }));
      })
      .catch(function () { cb(false); });
  }

  /* ---------- DOM ---------- */
  var modal = root.querySelector('.lcp__modal');
  var steps = {};
  root.querySelectorAll('[data-lcp-step]').forEach(function (el) {
    steps[el.getAttribute('data-lcp-step')] = el;
  });
  /* ---------- qualifier question bank (one question per visitor) ---------- */
  function parseBank(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      if (parts.length < 3) return null;
      return { key: parts[0].toLowerCase().replace(/[^a-z0-9_-]+/g, '-'), question: parts[1], options: parts.slice(2) };
    }).filter(Boolean);
  }
  function pickQuestion(bank) {
    if (!bank.length) return null;
    var forced = params.get('popup_q');
    if (forced) { for (var i = 0; i < bank.length; i++) { if (bank[i].key === forced) return bank[i]; } }
    if (cfg.qualifierRotation === 'daily') return bank[Math.floor(Date.now() / DAY_MS) % bank.length];
    return bank[Math.floor(Math.random() * bank.length)];
  }
  var activeQuestion = null;
  if (cfg.qualifierEnabled && steps.qualifier) {
    activeQuestion = pickQuestion(parseBank(cfg.qualifierBank));
    if (activeQuestion) {
      var qEl = steps.qualifier.querySelector('[data-lcp-question]');
      var choicesEl = steps.qualifier.querySelector('[data-lcp-choices]');
      if (qEl) qEl.textContent = activeQuestion.question;
      if (choicesEl) {
        choicesEl.innerHTML = '';
        activeQuestion.options.forEach(function (opt) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'button lcp__choice';
          b.setAttribute('data-lcp-choice', opt);
          b.textContent = opt;
          choicesEl.appendChild(b);
        });
        choicesEl.classList.toggle('lcp__choices--dense', activeQuestion.options.length > 4);
      }
    }
  }

  var SUCCESS = (cfg.codeDelivery === 'email' && steps['success-email']) ? 'success-email' : 'success';
  var order = [];
  if (steps.teaser) order.push('teaser');
  order.push('email');
  if (activeQuestion) order.push('qualifier');
  if (cfg.smsEnabled && steps.sms) order.push('sms');
  order.push(SUCCESS);

  var current = null;
  var isOpen = false;
  var lastFocused = null;
  var subscribedEmail = null;

  function emit(name, detail) {
    try {
      root.dispatchEvent(new CustomEvent('lcp:' + name, { bubbles: true, detail: detail || {} }));
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'lead_popup_' + name }, detail || {}));
      }
    } catch (e) { /* ignore */ }
  }

  function showStep(name) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
    current = name;
    var first = steps[name].querySelector('input:not([type=hidden]), button, a');
    if (first && !isTouch()) {
      window.setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 30);
    }
    emit('step', { step: name });
  }

  function nextStep() {
    var i = order.indexOf(current);
    var next = order[Math.min(i + 1, order.length - 1)];
    if (next === SUCCESS) enterSuccess();
    showStep(next);
  }

  function isTouch() {
    return window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('lcp-open');
    if (!preview) writeState({ shownAt: Date.now() });
    showStep(order[0]);
    emit('shown', { template: cfg.template });
  }

  function hide() {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    document.documentElement.classList.remove('lcp-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  /* Closing after the email was captured must never lose the code:
     jump to the reveal step instead of hiding. */
  function requestClose() {
    if (subscribedEmail && current !== SUCCESS) {
      enterSuccess();
      showStep(SUCCESS);
      return;
    }
    if (!subscribedEmail) {
      writeState({ dismissedAt: Date.now() });
      emit('dismissed', { step: current });
    }
    hide();
  }

  /* ---------- Klaviyo ---------- */
  function klaviyoPost(path, payload) {
    var url = KLAVIYO_BASE + path + '?company_id=' + encodeURIComponent(cfg.companyId);
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error('klaviyo_' + r.status);
        err.status = r.status;
        throw err;
      }
      return r;
    });
  }

  function baseProperties() {
    var p = {
      'Site Popup Coupon': cfg.discountCode || '',
      'Site Popup Page': window.location.pathname,
      'Site Popup Product': cfg.product || '',
      'Site Popup Template': cfg.templateSuffix || '',
      'Site Popup Landing': landed.path || '',
      'Site Popup Landing Product': landed.product || '',
      'Site Popup Referrer': landed.ref || '',
      'Site Popup Version': 'v3'
    };
    if (activeQuestion) p['Site Popup Question'] = activeQuestion.key;
    return p;
  }

  function subscribe(attrs, listId) {
    return klaviyoPost('subscriptions/', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Site popup',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  function updateProfile(attrs) {
    return klaviyoPost('profiles/', { data: { type: 'profile', attributes: attrs } });
  }

  // Fire a popup-specific Klaviyo event so the 'Popup Gift Code' flow emails the code.
  function fireClaimEvent(email, props) {
    return klaviyoPost('events/', {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Claimed Popup Gift' } } },
          properties: props || {},
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    }).catch(function () { /* non-blocking: the reveal/confirmation still shows */ });
  }

  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', { $email: email }]);
      }
    } catch (e) { /* ignore */ }
  }

  /* ---------- helpers ---------- */
  function setError(step, msg) {
    var el = step.querySelector('[data-lcp-error]');
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
  }

  function setLoading(step, on) {
    var btn = step.querySelector('[data-lcp-submit]');
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    btn.disabled = !!on;
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function normalizePhone(dial, raw) {
    var digits = String(raw || '').replace(/\D+/g, '');
    if (!digits) return null;
    if (dial === '+1') {
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      if (digits.length !== 10) return null;
    } else {
      if (digits.charAt(0) === '0') digits = digits.slice(1);
      if (digits.length < 7 || digits.length > 12) return null;
    }
    return dial + digits;
  }

  function autoApplyDiscount() {
    if (!cfg.autoApply || !cfg.discountCode) return;
    try {
      fetch('/discount/' + encodeURIComponent(cfg.discountCode), { credentials: 'same-origin', cache: 'no-store' })
        .catch(function () { /* ignore */ });
    } catch (e) { /* ignore */ }
  }

  var successEntered = false;
  function enterSuccess() {
    if (successEntered) return;
    successEntered = true;
    if (SUCCESS === 'success-email') {
      var sentTo = root.querySelector('[data-lcp-sent-to]');
      if (sentTo && subscribedEmail) sentTo.textContent = subscribedEmail;
      if (subscribedEmail) fireClaimEvent(subscribedEmail, baseProperties());
    } else {
      autoApplyDiscount();
    }
    emit('completed', { email: !!subscribedEmail, delivery: cfg.codeDelivery });
  }

  /* ---------- step: email ---------- */
  var emailStep = steps.email;
  emailStep.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var input = emailStep.querySelector('[data-lcp-email]');
    var email = (input.value || '').trim().toLowerCase();
    setError(emailStep, '');
    input.removeAttribute('aria-invalid');
    if (!validEmail(email)) {
      input.setAttribute('aria-invalid', 'true');
      setError(emailStep, 'Please enter a valid email address.');
      input.focus();
      return;
    }
    setLoading(emailStep, true);
    var attrs = {
      email: email,
      properties: baseProperties(),
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    subscribe(attrs, cfg.listId)
      .then(function () {
        subscribedEmail = email;
        writeState({ subscribedAt: Date.now() });
        identify(email);
        emit('subscribed', { channel: 'email' });
        setLoading(emailStep, false);
        nextStep();
      })
      .catch(function () {
        setLoading(emailStep, false);
        setError(emailStep, 'Something went wrong. Please try again in a moment.');
      });
  });

  /* ---------- step: qualifier ---------- */
  if (steps.qualifier) {
    steps.qualifier.addEventListener('click', function (ev) {
      var choice = ev.target.closest('[data-lcp-choice]');
      if (choice && activeQuestion) {
        var answer = choice.getAttribute('data-lcp-choice');
        var props = {};
        props['Site Popup Question'] = activeQuestion.key;
        props['Site Popup Answer'] = answer;
        props['Site Popup Q ' + activeQuestion.key] = answer;
        if (subscribedEmail) {
          updateProfile({ email: subscribedEmail, properties: props })
            .catch(function () { /* non-blocking */ });
        }
        emit('qualified', { question: activeQuestion.key, answer: answer });
        nextStep();
      }
    });
  }

  /* ---------- step: sms ---------- */
  if (steps.sms) {
    var smsStep = steps.sms;
    var country = smsStep.querySelector('[data-lcp-country]');
    if (country && cfg.defaultCountry) {
      for (var i = 0; i < country.options.length; i++) {
        if (country.options[i].value === cfg.defaultCountry) { country.selectedIndex = i; break; }
      }
    }
    smsStep.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-lcp-skip]')) nextStep();
    });
    smsStep.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = smsStep.querySelector('[data-lcp-phone]');
      var dial = country ? country.options[country.selectedIndex].getAttribute('data-dial') : '+1';
      var e164 = normalizePhone(dial, input.value);
      setError(smsStep, '');
      input.removeAttribute('aria-invalid');
      if (!e164) {
        input.setAttribute('aria-invalid', 'true');
        setError(smsStep, 'Please enter a valid phone number.');
        input.focus();
        return;
      }
      setLoading(smsStep, true);
      var attrs = {
        email: subscribedEmail || undefined,
        phone_number: e164,
        properties: baseProperties(),
        subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      subscribe(attrs, cfg.smsListId)
        .then(function () {
          emit('subscribed', { channel: 'sms' });
          setLoading(smsStep, false);
          nextStep();
        })
        .catch(function () {
          setLoading(smsStep, false);
          setError(smsStep, 'We could not save that number. Please check it and try again.');
        });
    });
  }

  /* ---------- step: success ---------- */
  var copyBtn = root.querySelector('[data-lcp-copy]');
  if (copyBtn) {
    var copyLabel = copyBtn.querySelector('[data-lcp-copy-label]');
    var originalLabel = copyLabel ? copyLabel.textContent : '';
    copyBtn.addEventListener('click', function () {
      var code = cfg.discountCode || '';
      var done = function () {
        if (copyLabel) {
          copyLabel.textContent = 'Copied!';
          window.setTimeout(function () { copyLabel.textContent = originalLabel; }, 1800);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var sel = root.querySelector('[data-lcp-code]');
        if (sel && window.getSelection) {
          var range = document.createRange();
          range.selectNodeContents(sel);
          var s = window.getSelection();
          s.removeAllRanges();
          s.addRange(range);
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
        }
        done();
      }
    });
  }
  /* ---------- global close handlers ---------- */
  root.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-lcp-close]')) {
      ev.preventDefault();
      requestClose();
      return;
    }
    // "Start shopping" just closes the popup — it never navigates anywhere.
    if (ev.target.closest('[data-lcp-cta]')) {
      ev.preventDefault();
      hide();
      return;
    }
    if (ev.target.closest('[data-lcp-next]')) {
      ev.preventDefault();
      nextStep();
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (!isOpen) return;
    if (ev.key === 'Escape') {
      ev.preventDefault();
      requestClose();
      return;
    }
    if (ev.key === 'Tab') {
      var focusables = Array.prototype.filter.call(
        modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }
  });

  /* ---------- boot ---------- */
  if (!eligible()) return;
  gate(function (allowed) {
    if (!allowed) return;
    var delay = preview ? 0 : Math.max(0, Number(cfg.delaySeconds) || 0) * 1000;
    window.setTimeout(open, delay);
  });
})();
